import React, { useState }        from "react";
import MedicalCertificateService  from 'services/medical-certificate.service';
import AuthService                from 'services/auth.service';
import MedicalCertificateTable    from './MedicalCertificateTable';
import { Modal }                  from "react-bootstrap";
import CloseBtn                   from 'assets/icons/Close.svg';
import Spinner                    from 'react-bootstrap/Spinner';

function MedicalCertificateSubmitConfirmModal({setShowMcConfirm, showMcConfirm, mc, getDaysDiff, setCertified}) {
  const [submitting, setSubmitting] = useState(false); 

  const submitMc = () => {
    setSubmitting(true);
    MedicalCertificateService.submitMedicalCertificate(mc).then(
      (data) => {
        setSubmitting(false);
        setCertified(data.medical_certificate.id)
      },
      (error) => {
        setSubmitting(false);
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
        if (error.response?.data?.error) {
          alert(error.response?.data?.error);
        }
        if (error.response?.data?.errors) {
          alert(error.response?.data?.errors[0]);
        }
      }
    );
  }

  return (
    <Modal className="medicine-details-modal" size="lg" show={showMcConfirm} onHide={() => {setShowMcConfirm(false)}} backdrop="static" keyboard={false}>
      <Modal.Header>
        <button type="button" className="close" onClick={() => {setShowMcConfirm(false)}}>
            <img src={ CloseBtn } alt="modal-close" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <h6>Confirmation</h6>
        <p>Please note that the following medical certificate is issued correctly. You are not able to make changes once you submitted.</p>
        <MedicalCertificateTable mc={mc} getDaysDiff={getDaysDiff}/>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-100 d-flex justify-content-end">
          <div>
            {submitting ? <Spinner animation="border" className="spinner"/> : <button className="btn btn-danger" onClick={submitMc}>Confirm & Send</button> }
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default MedicalCertificateSubmitConfirmModal;
